import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ManagedUserGroup,
  QueryUserGroupsWithAccessToSpaceArgs,
  QueryUserGroupsWithAccessToSpaceSuggestionsArgs,
  Role,
  SearchSuggestionsOutput,
  Space,
  UserGroupSpaceAccessRoleGrant,
  UserGroupsWithAccessToSpaceOutput,
} from "types/generated";

type SpaceDetailsIdpGroupGrantNode = Pick<UserGroupSpaceAccessRoleGrant, "propagated"> & {
  role: Pick<Role, "id" | "name" | "isSystem">;
  space: Pick<Space, "id" | "name">;
};

type SpaceDetailsIdpGroupNode = {
  userGroup: Pick<ManagedUserGroup, "id" | "groupName">;
  roles: Array<SpaceDetailsIdpGroupGrantNode>;
};

type UserGroupsWithAccessToSpaceData = {
  userGroupsWithAccessToSpace: {
    edges: Array<{ cursor: string; node: SpaceDetailsIdpGroupNode }>;
    pageInfo: UserGroupsWithAccessToSpaceOutput["pageInfo"];
  };
};

export const USER_GROUPS_WITH_ACCESS_TO_SPACE: TypedDocumentNode<
  UserGroupsWithAccessToSpaceData,
  QueryUserGroupsWithAccessToSpaceArgs
> = gql`
  query UserGroupsWithAccessToSpace($space: ID!, $input: SearchInput!) {
    userGroupsWithAccessToSpace(space: $space, input: $input) {
      edges {
        cursor
        node {
          userGroup {
            id
            groupName
          }
          roles {
            propagated
            role {
              id
              name
              isSystem
            }
            space {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type UserGroupsWithAccessToSpaceCountData = {
  userGroupsWithAccessToSpaceSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const USER_GROUPS_WITH_ACCESS_TO_SPACE_COUNT: TypedDocumentNode<
  UserGroupsWithAccessToSpaceCountData,
  QueryUserGroupsWithAccessToSpaceSuggestionsArgs
> = gql`
  query UserGroupsWithAccessToSpaceCount($space: ID!, $input: SearchSuggestionsInput!) {
    userGroupsWithAccessToSpaceSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
